import {
  Box,
  LinearProgress,
  Modal,
  Paper,
  Theme,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as React from "react";

interface ModalLinearActivityIndicatorProps {
  headerText?: string;
  descriptionText?: string;
}

const ModalLinearActivityIndicator = (
  props: ModalLinearActivityIndicatorProps
) => {
  const [open] = React.useState(true);
  const theme: Theme = useTheme();
  const {
    headerText = "Loading",
    descriptionText = "Please wait, this may take a moment",
  } = props;

  return (
    <Modal
      sx={{
        backgroundColor:
          theme.custom.styles.modalLoadingIndicatorStyle.backDropColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop: { xs: "100px", sm: "120px", md: "150px" },
      }}
      open={open}
    >
      <Paper
        elevation={3}
        sx={{
          borderRadius: theme.custom.styles.linearProgressBarStyle.borderRadius,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          minWidth: "310.25px",
          height: "226px",
          outline: "none",
        }}
      >
        <Typography sx={theme.custom.styles.linearProgressBarStyle.header}>
          {headerText}
        </Typography>

        <Box sx={{ width: "fit-content", px: 3 }}>
          <Typography
            sx={theme.custom.styles.linearProgressBarStyle.description}
          >
            {descriptionText}
          </Typography>

          <Box sx={{ mt: 2 }}>
            <LinearProgress
              sx={{
                borderRadius: "4px",
                backgroundColor:
                  theme.custom.styles.linearProgressBarStyle.secondaryBarColor,
                "& .MuiLinearProgress-bar": {
                  backgroundColor:
                    theme.custom.styles.linearProgressBarStyle.primaryBarColor,
                },
              }}
            />
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};

export default ModalLinearActivityIndicator;
